(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["page-pro-bulk-template"]) return;
  try {
    
(function() {
  var field = document.getElementById('pro-bulk-items');
  if (!field) return;

  var params = new URLSearchParams(window.location.search);
  var title = params.get('quote_item');
  var sku = params.get('quote_sku');
  var url = params.get('quote_url');
  var addition = '';

  if (title) {
    addition = '1 x ' + title;
    if (sku) addition += ' (SKU: ' + sku + ')';
    if (url) addition += '\n' + url;
  }

  if (!addition) return;

  var current = field.value.trim();
  if (current.indexOf(title) === -1) {
    field.value = addition + (current ? '\n\n' + current : '');
    field.classList.add('is-filled');
  }
})();

  } catch(e) { console.error(e); }
})();
})();
